import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';

export const useStopwatchDuration = (originalTime: string, skip = false) => {
  const [duration, setDuration] = useState(null);

  useEffect(() => {
    if (skip) return;

    const start = DateTime.fromISO(originalTime);

    const interval = setInterval(() => {
      const diff = DateTime.now()
        .diff(start)
        .shiftTo('hours', 'minutes', 'seconds');

      setDuration(diff);
    }, 1000);

    return () => clearInterval(interval);
  }, [originalTime, skip]);

  return duration;
};
